module.exports = __webpack_public_path__ + "img/_2.f9f64654.png";